import React, { useState } from 'react'
import { MenuItem, TextField } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import moment from 'moment';
import 'moment/locale/es';
import * as locales from 'react-date-range/dist/locale';
import Swal from 'sweetalert2';
import { Button, Grid, makeStyles} from '@material-ui/core';
import ListAltIcon from '@material-ui/icons/ListAlt';

import { COLORS_PROJECT } from '../../../constants';
import {getInformationdateR } from '../../../actions/lightning';


//CONST FOR DATES
moment.locale("es");
const {color_nav}=COLORS_PROJECT;

const firstDate = moment().subtract(7,'days')
const endPlus = firstDate.clone().add(7,'days')
const today = moment().toDate()
const initialDate = moment('2021-01-01').toDate()

const initialState =[
    {
      startDate: firstDate.toDate(),
      endDate: endPlus.toDate(),
      key: 'selection'
    }
]

/**
 * To make style of the component
 */
const useStyles = makeStyles((theme)=>({
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        paddingLeft: theme.spacing(4),
        textAlign:'center',
        justifyContent: 'center',
    },
}))

export const DateRangePickerRayos = () => {
    const classes = useStyles();

    const dispatch = useDispatch()
    const uid = useSelector((state) => state.auth.uid);
    const [format, setFormat] = useState('csv');
    

    /**
     * To select the point name
     * @param {object} fieldName -Object with point name
     * @param {object} newValue -Object with new point name
     */
    

    const [state, setState] = useState(initialState);
    const [dateRange] = state;
    const {startDate,endDate}= dateRange;

    /**
     * Function to select range 
     * @param {Event} item 
     */
    const handleChange = (item) =>{
        setState([item.selection])
    }

    /**
     * Function that allows obtaining the selected dates 
     * @param {Event} e 
     */
    const handleSubmitForm = (e) =>{
        e.preventDefault();
        const momentStart = moment(startDate);
        const momentEnd   = moment(endDate);
        const momentValidationDate =momentStart.clone().add(30,'days')

        if(momentStart.isAfter(momentEnd)){
            return Swal.fire('Error','Fecha fin debe ser mayor a la fecha de inicio','error')
        }else if(momentEnd.isAfter(momentValidationDate)){
            return Swal.fire('Error','La fecha final no debe ser mayor a un mes','error')
        }else{
            const formatStart = momentStart.format('YYYY-MM-DD').toString()
            const formatEnd = momentEnd.format('YYYY-MM-DD').toString()
            dispatch(getInformationdateR(formatStart,formatEnd,format,uid))
        }

    }

    return (
        <Grid container spacing={3} className={classes.container}>
            <form  onSubmit={handleSubmitForm}>
                
                <h1></h1>   
                
                <Grid item xs={12} md={12} lg={12} sx={{ mt: 2 }} >
                    <TextField
                        select
                        fullWidth
                        label="Formato de descarga"
                        value={format} // valor del estado
                        onChange={(e) => setFormat(e.target.value)} // actualiza el estado
                    >
                        <MenuItem value="csv">CSV</MenuItem>
                        <MenuItem value="kml">KML</MenuItem>
                    </TextField>
                </Grid>   

                <Grid  item xs={12} md={12} lg={12} style={{ marginTop: '20px' }}>
                    <DateRange
                        label="Rango de fechas"
                        locale={locales['es']}
                        rangeColors = {[color_nav]}
                        onChange={handleChange}
                        ranges={state}
                        editableDateInputs={true}
                        moveRangeOnFirstSelection={false}
                        showPreview={false}
                        minDate={initialDate}
                        maxDate={today}
                    />
                </Grid> 
                 
                <Grid  item xs={12} md={12} lg={12} sx={{ mt: 2 }} style={{ marginTop: '20px' }}>
                 
                    <Button 
                        variant="contained" 
                        color="primary" 
                        type="submit" 
                        size="large"
                        startIcon={<ListAltIcon/>}
                    >
                        Generar
                    </Button>
                </Grid>
            </form>
        </Grid>
    )
}
